<template>
  <div v-if="showFields" class="parent">
    <div class="textInput">
      <label class="label" for="tbox1">{{ Title }}</label>
      <span class="counter">{{ remaningLengthDescription }}/{{ maxDescription }}</span>
      <textarea
        class="input"
        name="tbox1"
        id="tbox1"
        :maxlength="maxDescription"
        :placeholder="addDescription"
        rows="8"
        cols="33"
        :value="description"
        @input="$emit('onChange', handleEmit($event.target))"
      ></textarea>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Description",
  props: {
    Title: {
      type: String,
      default: ""
    },
    showFields: {
      type: Boolean,
      default: false
    },
    remaningLengthDescription: {
      type: Number,
      default: 0
    },
    maxDescription: {
      type: Number,
      default: 200
    },
    description: {
      type: String,
      default: ""
    }
  },
  emits: ["onChange"],
  data() {
    return {
      addDescription: this.$t("operationCreateComp.addDescriptionHere")
    };
  },
  methods: {
    handleEmit(target: EventTarget | null) {
      return (target as HTMLInputElement).value;
    }
  }
});
</script>

<style scoped>
.input {
  border-color: rgba(0, 0, 0, 0.08);
  color: #424242;
  background-color: #ffffff;
  height: 148px;
  width: 250px;
}
.label {
  font-size: 16px;
}
.counter {
  position: absolute;
  top: 160px;
  left: 218px;
  color: #767474;
  font-size: 12px;
  z-index: 999;
}
</style>
